﻿"use strict";
let loginRequest = {
    login: "",
    password: ""
}
let canClose = true;

export function pageInit(continuation) {
    const template = function () {
        const container = $("<div />");
        const formElement = $("<div />").appendTo(container);
        const summaryElement = $('<div id="loginCustomValidationSummary"/>').appendTo(container);
        summaryElement.dxValidationSummary();
        formElement.dxForm({
            labelMode: "outside",
            labelLocation: "left",
            formData: loginRequest,
            minColWidth: 450,
            colCount: 1,
            showValidationSummary: true,
            validationGroup: 'dataValidation',
            items: [
                {
                    dataField: "login", label: { text: "Anmeldename" },
                    validationRules: [
                        { type: "required", message: "Anmeldename muß angegeben werden." }
                    ]
                },
                {
                    dataField: "password", label: { text: "Passwort" },
                    editorOptions: { mode: "password" },
                    validationRules: [
                        { type: "required", message: "Passwort muß angegeben werden." }
                    ]
                }
            ]
        }); // formElement
        return container;
    }; // template

    const popupTitle = "Anmeldung [KAV RP Personalstandserhebung " + (window.CONFIG.specialLogin === "neu" ? "Neumitglied" : "online") + "]";
    const popup = $("#login").dxPopup({
        width: 600,
        height: "auto",
        showTitle: true,
        title: popupTitle, // `Anmeldung [KAV RP Personalstandserhebung online]`,
        showCloseButton: false,
        visible: false,
        shading: true,
        resizeEnabled: false,
        contentTemplate: template,
        onInitialized(e) {
            e.component.registerKeyHandler("escape", function (arg) { // ESC soll nicht das Popup schließen...
                arg.stopPropagation();
            });
        },
        onShown(e) {
            // das zusätzliche ValidationSummary-Widget für die Meldungen aus dem HTTP Request abholen
            popup.kavCustomValidationSummary = $("#loginCustomValidationSummary").dxValidationSummary("instance");
        },
        toolbarItems: [
            {
                widget: "dxButton",
                toolbar: "bottom",
                location: "after",
                options: {
                    text: "Abbrechen",
                    icon: "close",
                    onClick() {
                        // kein hide, dann stehen wir bei "back" von CONFIG.home wieder im Login Popup
                        location.href = CONFIG.home;
                    }
                }
            },
            {
                widget: "dxButton",
                toolbar: "bottom",
                location: "after",
                options: {
                    text: "OK",
                    icon: "check",
                    validationGroup: 'dataValidation',
                    onClick(e) {
                        const validationResult = e.validationGroup.validate();
                        if (validationResult.isValid) {
                            const url = new URL(window.CONFIG.serverApi + "/login");
                            const request = {
                                cache: false,
                                url: url,
                                contentType: 'application/json',
                                method: 'POST',
                                data: JSON.stringify(loginRequest),
                                success: function (response) {
                                    popup.hide();
                                    continuation(response);
                                },
                                error: function (jqXHR) {
                                    if (jqXHR.responseJSON && jqXHR.responseJSON.code) {
                                        t.showRequestErrorInDialog("Fehler bei der Anmeldung", jqXHR, popup.kavCustomValidationSummary);
                                        form.getEditor("login").focus();
                                    } else {
                                        popup.hide();
                                        t.showErrorInPage(jqXHR);
                                    }
                                }
                            };
                            $.ajax(request);
                        }
                    }
                }
            }
        ] // toolbarItems

    }).dxPopup("instance"); // popup
    popup.show();
}